import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
// import "../LoginPage/LoginPage.css";
import Logo from "../../assets/images/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Influencerlogin, InfluencerPasswordUpdate, login } from "../api/api";
import OneSignal from "react-onesignal";
import "../InfluencerPage/InflucerEnterCode.css";
import bgImage from "../../assets/images/brown-background.jpg";
import { v4 as uuidv4 } from "uuid";

const InflucerEnterCode = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [deviceToken, setDeviceToken] = useState("");
  const [jwtsToken, setjwtsToken] = useState("");
  const location = useLocation();
  const email = location?.state?.email || "";
  console.log("emal", email);
  const validationSchema = Yup.object({
    code: Yup.string().required("OTP is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[a-z]/, "Password must contain a lowercase letter")
      .matches(/[A-Z]/, "Password must contain an uppercase letter")
      .matches(/\d/, "Password must contain a number")
      .matches(
        /[!@#$%^&*_]/,
        // 'Password must contain a special character (#?!@$%^&*_)',
        "Your password can include letters, numbers, and special characters (!, ?, @, #, %, &). For your security, please create a strong password."
      )
      .required("Password is required"),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const showAlert = (message, callback) => {
    Swal.fire({
      title: "",
      text: message,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };
  const showErrorAlert = (message, callback) => {
    Swal.fire({
      title: "Failed",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };
  const handleSubmit = async (values) => {
    console.log("values-in-login0", values);
    try {
      setIsLoading(true);
      const response = await InfluencerPasswordUpdate(values);
      console.log("response123456", response);
      if (response?.success) {
        // localStorage.setItem("influencerData", JSON.stringify(response?.data));
        showAlert(response?.message, () => navigate("/AffiliateAccess"));
      } else {
        showErrorAlert(response?.message);
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="EnterInlogin-box"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Formik
        initialValues={{
          email: email,
          password: "",
          code: "",
          // jwt: jwtsToken,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ isSubmitting }) => (
          <Form className="EnterInlogin-form">
            <img src={Logo} alt="Logo" className="EnterInlogin-logo" />
            <h1 className="EnterInlogin-heading">Set Password</h1>
            <div className="EnterInloginform-group">
              <label>Code</label>
              <Field
                type="text"
                name="code"
                className="EnterInform-input"
                // placeholder="Enter your email"
              />
              <ErrorMessage
                name="code"
                component="div"
                className="EnterInerror-message"
              />
            </div>
            <div className="EnterInloginform-group">
              <label>Password</label>
              <Field
                type="password"
                name="password"
                className="EnterInform-input"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="EnterInerror-message"
              />
            </div>
            <div className="EnterInloginform-group">
              <label>Confirm Password</label>
              <Field
                type="password"
                name="confirmpassword"
                className="EnterInform-input"
              />
              <ErrorMessage
                name="confirmpassword"
                component="div"
                className="EnterInerror-message"
              />
            </div>
            <button
              type="submit"
              className="EnterInlogin-button"
              disabled={isSubmitting || isLoading}
            >
              {isLoading ? "Save..." : "Save"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default InflucerEnterCode;
